


// import React from 'react';
// import membershipImage from '../assets/PrimeMembershipImg.jpg'; // Replace with the actual path of your image

// const PrimeMembership = () => {
//   return (
//     <div className="w-full mx-auto bg-white p-4 sm:p-6 md:p-14">
//       {/* Title */}
//       <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold text-center text-[#FF9630] mb-8 md:mb-12">
//         Get Your Prime Membership Now
//       </h2>

//       {/* Content Section */}
//       <div className="flex flex-col md:flex-row items-center md:items-start gap-8 md:gap-12">
        
//         {/* Image Section */}
//         <div className="w-full md:w-1/2 flex justify-center">
//           <img
//             src={membershipImage}
//             alt="Prime Membership"
//             className="w-full h-auto max-h-[250px] sm:max-h-[300px] md:max-h-[350px] rounded-lg object-cover"
//           />
//         </div>

//         {/* Text Content */}
//         <div className="w-full md:w-1/2 space-y-6 md:space-y-8">
//           <h3 className="text-lg sm:text-2xl font-semibold text-gray-800">
//             Rev Up Your Ride with Our $1000 Ultimate <br/><span className="font-normal">Membership – More Freedom, Less Hassle!</span>
//           </h3>

//           {/* List Items */}
//           <ul className="list-none space-y-2 text-left text-sm sm:text-lg">
//             <li className="flex items-start">
//               <span className="mr-2">•</span>
//               <span>Unlimited Access: Ride any motorcycle, anytime, with unlimited rentals throughout the year.</span>
//             </li>
//             <li className="flex items-start">
//               <span className="mr-2">•</span>
//               <span>Exclusive Perks: Priority bookings, special discounts on accessories, and free maintenance checks.</span>
//             </li>
//             <li className="flex items-start">
//               <span className="mr-2">•</span>
//               <span>Ride Without Worry: No hidden fees, comprehensive insurance, and 24/7 roadside assistance included.</span>
//             </li>
//           </ul>

//           {/* Buy Now Button */}
//           <button className="mt-6 md:mt-8 bg-[#FF9630] text-white px-4 py-2 sm:px-6 sm:py-3 rounded-md w-full text-md font-semibold hover:bg-[#FF9630] transition duration-300">
//             BUY NOW
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PrimeMembership;

import React from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import membershipImage from '../assets/PrimeMembershipImg.jpg'; // Replace with the actual path of your image

const PrimeMembership = () => {
  const navigate = useNavigate(); // Initialize navigate

  const handleBuyNow = () => {
    navigate('/membership-card'); // Replace with your target route
  };

  return (
    <div className="w-full mx-auto bg-white p-4 sm:p-6 md:px-16">
      {/* Title */}
      <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold text-center text-[#FF9630] mb-8 md:mb-12">
        Get Your Prime Membership Now
      </h2>

      {/* Content Section */}
      <div className="flex flex-col md:flex-row items-center md:items-start gap-8 md:gap-12">
        {/* Image Section */}
        <div className="w-full md:w-1/2 flex justify-center">
          <img
            src={membershipImage}
            alt="Prime Membership"
            className="w-full h-auto max-h-[250px] sm:max-h-[300px] md:max-h-[350px] rounded-lg object-cover"
          />
        </div>

        {/* Text Content */}
        <div className="w-full md:w-1/2 space-y-6 md:space-y-8">
          <h3 className="text-lg sm:text-2xl font-semibold text-gray-800">
            Rev Up Your Ride with Our $1000 Ultimate <br />
            <span className="font-normal">Membership – More Freedom, Less Hassle!</span>
          </h3>

          {/* List Items */}
          <ul className="list-none space-y-2 text-left text-sm sm:text-lg">
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>Unlimited Access: Ride any motorcycle, anytime, with unlimited rentals throughout the year.</span>
            </li>
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>Exclusive Perks: Priority bookings, special discounts on accessories, and free maintenance checks.</span>
            </li>
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>Ride Without Worry: No hidden fees, comprehensive insurance, and 24/7 roadside assistance included.</span>
            </li>
          </ul>

          {/* Buy Now Button */}
          <button
            onClick={handleBuyNow} // Add onClick handler
            className="mt-6 md:mt-8 bg-[#FF9630] text-white px-4 py-2 sm:px-6 sm:py-3 rounded-md w-full text-md font-semibold hover:bg-[#FF9630] transition duration-300"
          >
            BUY NOW
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrimeMembership;

